export const APP = {
  LOADING: 'LOADING',
  BUTTON_LOADING: 'BUTTON_LOADING',

  SET_MODAL: 'SET_MODAL',
  SET_MODAL_DATA: 'SET_MODAL_DATA',
  SET_MODAL_ADDITIONAL: 'SET_MODAL_ADDITIONAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  CLOSE_MODAL_ADDITIONAL: 'CLOSE_MODAL_ADDITIONAL',

  ERROR_SNACK_OPEN: 'ERROR_SNACK_OPEN',
  ERROR_SNACK_CLOSE: 'ERROR_SNACK_CLOSE',

  SUCCESS_SNACK_OPEN: 'SUCCESS_SNACK_OPEN',
  SUCCESS_SNACK_CLOSE: 'SUCCESS_SNACK_CLOSE',

  SHOW_CONFIRM_POPUP: 'SHOW_CONFIRM_POPUP',
  HIDE_CONFIRM_POPUP: 'HIDE_CONFIRM_POPUP'
};

export const POPUPS = {
  PREPARING_POPUP: 'preparing',
  COMPANY_POPUP: 'company',
  PROJECT_POPUP: 'project',
  MAILING_POPUP: 'mailing',
  REVIEW_POPUP: 'review',
  STATUS_DOC: 'status_doc',
  SUPPORT_POPUP: 'support',
  AVATAR_POPUP: 'avatar',
  AVATAR_EDIT_POPUP: 'avatarEdit',
  AVATAR_PROJECT_EDIT_POPUP: 'avatarEditProject',
  AVATAR_USER_POPUP: 'avatarUser',
  EDIT_DICTIONARIES: 'edit_dictionary',
  EDIT_USER: 'editUser',
  VIDEO_POPUP: 'videoPopUp',
  PHOTO_PREVIEW: 'photoPreview',
  MULTI_EMPLOYEE_POPUP: 'multiEmployeePopup',
};
